var environment_id = "pr";

// initCommandリスト
var initCommandList = {
    "dev" : "",
    "dev_mock" : `utility.loadScript("../mock/js/jquery.mockjax-2.5.0.js", function () {
                    console.log('script loaded');
                    $.mockjaxSettings.matchInRegistrationOrder = false;
                    utility.loadScript("../mock/productInfo/normal.js", function () {
                        console.log('mock script loaded.');
                        // 共通の商品選択の画面表示処理呼び出し
                        page.showSelectScreen();
                    });
                });`,
    "browserstack" : "",
    "it1" : "",
    "it2" : "page.showSelectScreen();",
    "st" : "",
    "jedi_ols_st" : "page.showSelectScreen();",
    "pr" : "page.showSelectScreen();",
    "default" : "page.showSelectScreen();"
};

// OTP発行リスト
var otpList = {
    "dev" : "",
    "dev_mock" : `utility.loadScript("../mock/js/jquery.mockjax-2.5.0.js", function () {
                    console.log('script loaded');
                    $.mockjaxSettings.matchInRegistrationOrder = false;
                    utility.loadScript("../mock/oneTimePassword/normal.js", function () {
                        console.log('mock script loaded.');
                        // 認証対象取得処理呼び出し
                        page.otpUser();
                    });
                });`,
    "browserstack" : "",
    "it1" : "",
    "it2" : "page.otpUser();",
    "st" : "",
    "jedi_ols_st" : "page.otpUser();",
    "pr" : "page.otpUser();",
    "default" : "page.otpUser();"
};

// 購入履歴のMock
var purchaseHistoryMock = {
    "dev" : "",
    "dev_mock" : `utility.loadScript("../mock/js/jquery.mockjax-2.5.0.js", function () {
                    console.log('script loaded');
                    $.mockjaxSettings.matchInRegistrationOrder = false;
                    utility.loadScript("../mock/purchaseHistory/purchaseHistoryMock.js", function () {
                        console.log('mock script loaded.');
                        //購入履歴画面に必要な情報ロード
                        purchaseHistoryloadData();
                    });
                });`,
    "browserstack" : "",
    "it1" : "",
    "it2" : "purchaseHistoryloadData();",
    "st" : "",
    "jedi_ols_st" : "purchaseHistoryloadData();",
    "pr" : "purchaseHistoryloadData();",
    "default" : "purchaseHistoryloadData();"
};

// Casis連携のMock
var casisMock = {
    "dev" : "",
    "dev_mock" : `utility.loadScript("../mock/js/jquery.mockjax-2.5.0.js", function () {
                    console.log('script loaded');
                    $.mockjaxSettings.matchInRegistrationOrder = false;
                    utility.loadScript("../mock/productInfo/goToPayment.js", function () {
                        console.log('mock script loaded.');
                        //Casis連携
                        page.goToPaymentScreen();
                    });
                });`,
    "browserstack" : "",
    "it1" : "",
    "it2" : "page.goToPaymentScreen();",
    "st" : "",
    "jedi_ols_st" : "page.goToPaymentScreen();",
    "pr" : "page.goToPaymentScreen();",
    "default" : "page.goToPaymentScreen();"
};

// 購入確認のMock
var purchaseCompleteMock = {
    "dev" : "",
    "dev_mock" : `utility.loadScript("../mock/js/jquery.mockjax-2.5.0.js", function () {
                    console.log('script loaded');
                    $.mockjaxSettings.matchInRegistrationOrder = false;
                    utility.loadScript("../mock/purchaseComplete/purchaseCompleteMock.js", function () {
                        console.log('mock script loaded.');
                        //購入確認画面に必要な情報ロード
                        loadData();
                    });
                });`,
    "browserstack" : "",
    "it1" : "",
    "it2" : "loadData();",
    "st" : "",
    "jedi_ols_st" : "loadData();",
    "pr" : "loadData();",
    "default" : "loadData();"
};






// 認証URLリスト
var approveurlList = {
    "dev" : "loginMock.html",
    "dev_mock" : "loginMock.html",
    "browserstack" : "loginMock.html",
    "it1" : "loginMock.html",
    "it2" : "/aw/login",
    "st" : "loginMock.html",
    "jedi_ols_st" : "/aw/login/",
    "pr" : "/aw/login/",
    "default" : "/aw/login"
};

// GA実行stringリスト
var gaList = {
    "dev": "",
    "dev_mock" : "",
    "browserstack" : "",
    "it1": "",
    "it2": "",
    "st": "",
    "jedi_ols_st" : "",
    "pr": "startGA",
    "default": ""
}

// オンラインショップギフトカードリスト
var onlineShopGiftCardList = {
    "dev" : "https://www.softbank.jp/mobile/special/itunes-test1/",
    "dev_mock" : "https://www.softbank.jp/mobile/special/itunes-test1/",
    "browserstack" : "https://www.softbank.jp/mobile/special/itunes-test1/",
    "it1" : "https://www.softbank.jp/mobile/special/itunes-test1/",
    "it2" : "https://www.softbank.jp/mobile/special/itunes-test1/",
    "st" : "https://www.softbank.jp/mobile/special/itunes-test2/",
    "jedi_ols_st" : "https://www.softbank.jp/mobile/special/itunes-test2/",
    "pr" : "https://www.softbank.jp/mobile/special/itunes/",
    "default" : "https://www.softbank.jp/mobile/special/itunes/"
};

// 残高を確認するページのリンクリスト
var balanceConfirmationList = {
    "dev" : "https://my.softbank.jp/msb/d/webLink/doSend/MCBCB0000",
    "dev_mock" : "https://my.softbank.jp/msb/d/webLink/doSend/MCBCB0000",
    "browserstack" : "https://my.softbank.jp/msb/d/webLink/doSend/MCBCB0000",
    "it1" : "https://my.softbank.jp/msb/d/webLink/doSend/MCBCB0000",
    "it2" : "https://my.softbank.jp/msb/d/webLink/doSend/MCBCB0000",
    "st" : "https://my.softbank.jp/msb/d/webLink/doSend/MCBCB0000",
    "jedi_ols_st" : "https://my.softbank.jp/msb/d/webLink/doSend/MCBCB0000",
    "pr" : "https://my.softbank.jp/msb/d/webLink/doSend/MCBCB0000",
    "default" : "https://my.softbank.jp/msb/d/webLink/doSend/MCBCB0000"
}